import VideoAdTopElement from "$src/js/components/organisms/video-ad-top/VideoAdTop.svelte";
import { mount } from "svelte";

export class VideoAdTop {
    targets: NodeListOf<HTMLElement> = document.querySelectorAll('.js-ad-container');

    constructor() {
        if (!this.targets.length) {
            return;
        }

        this.render();
    }

    render() {
        this.targets.forEach((target) => {
            mount(VideoAdTopElement, {
                target: target,
                props: {
                    position: (target.dataset.position ?? 'site-top') as 'site-top' | 'content-item-detail'
                }
            });
        });
    }
}
